export const SECTION_ID = {
  about: 'about-section',
  solutions: 'solutions-section',
  clients: 'clients-section',
  faq: 'faq-section',
  contacts: 'contacts-section',
};
